import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/Layout/Header/Header";
import Footer from "../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../components/Common/ScrollTop";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import SearchModal from "../../../components/Layout/Header/SearchModal";
// Image
import footerLogo from "../../../assets/img/logo/lite-logo.png";

import QuickLinks from "../../../components/Common/QuickLinks";
import { BlocksRenderer } from "../../../components/BlockRenderer";
import { fetchData } from "../../../utils/fetchData";
import {
  getAPIPath,
  getMenu,
  getPageTitle,
} from "../../../utils/getDomainData";
function groupByYear(data) {
  const groupedData = [];

  data.forEach((entry) => {
    const year = entry.attributes.Year;
    const existingGroup = groupedData.find((group) => group.year === year);

    if (existingGroup) {
      existingGroup.entries.push(entry);
    } else {
      groupedData.push({
        year,
        entries: [entry],
      });
    }
  });

  return groupedData;
}
const ResearchScholars = () => {
  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    fetchData(getAPIPath()?.Research_Scholars, setData);
    fetchData(getAPIPath()?.Particulars_of_Research_scholars, setTableData);
  }, []);
  return (
    <React.Fragment>
      <Helmet>
        <title>Research Scholars – {getPageTitle()}</title>
        <meta name="description" content="" />
        <meta name="keywords" content=""></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <div className="pageTopOffset">
        <SiteBreadcrumb
          pageTitle="Research Scholars"
          pageName="Research Scholars"
          breadcrumbsClass="breadcrumb-bg"
        />
        {getMenu()}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col-lg-9 md-mb-30">
                <div className="content-wrapper">
                  <div className="content-section">
                    <h3 style={{ marginBottom: "20px" }} title={data?.data?.attributes?.Page_Heading}>
                      {data?.data?.attributes?.Page_Heading}
                    </h3>
                    {
                      <BlocksRenderer
                        content={data?.data?.attributes?.Body || []}
                      />
                    }
                  </div>
                  <h4 style={{ marginTop: "20px" }} title="Particulars of Research scholars">
                    Particulars of Research scholars
                  </h4>
                  <table class="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">Name & Contact details</th>
                        <th scope="col"> Supervisor/Co-Supervisor</th>
                        <th scope="col"> Research domain</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(groupByYear(tableData?.data || []) || [])?.map(
                        (obj, index) => (
                          <>
                            <tr>
                              <td colspan={5}>{obj?.year}</td>
                            </tr>
                            {obj?.entries?.map((objNow) => (
                              <tr>
                                <td>
                                  <BlocksRenderer
                                    content={
                                      objNow?.attributes
                                        ?.Name_And_Contact_Details
                                    }
                                  />
                                </td>
                                <td>
                                  <BlocksRenderer
                                    content={
                                      objNow?.attributes
                                        ?.Supervisor_Co_Supervisor
                                    }
                                  />
                                </td>
                                <td>{objNow?.attributes?.Research_Domain}</td>
                              </tr>
                            ))}
                          </>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-lg-3 pl-20 md-pl-14">
                <div className="about-intro">
                  <QuickLinks />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Accredation /> */}

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup secondaryColor" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default ResearchScholars;
